/**
  * @param options - Optional parameters.
  * @param htmlElements - html objects.
  * @param strings - Al text strings in javascript (useful for translations).
  */


function Documents(options, htmlElements, strings){
	this.htmlElements = htmlElements;

	// default options
	this.options = {
		'allowMultipleCopies' : false,
		'defaultProductType' : null
	};

	// merge input options with default options
	for (let attrname in options) { this.options[attrname] = options[attrname]; }

	// default strings
	this.strings = {
		'loading' : 'Loading..',
		'documents' : 'Documents',
		'chooseYourProduct' : 'Choose your product',
		'chooseProduct' : 'choose product',
		'noDocumentsFound' : 'No documents found',
		'receiveByMail' : 'Receive by mail',
		'add' : 'Add',
	};

	this.currentProductType = (this.options.defaultProductType) ? this.options.defaultProductType : null;

	// eventDistpatcher
	this.eventDispatcher = document.createElement('div');// hacky

	// events
	this.events = [];

	this.events.productsLoaded = new CustomEvent('products-loaded');
	this.events.documentsLoaded = new CustomEvent('documents-loaded');

	// merge input strings with default options
	for (let attrname in strings) { this.strings[attrname] = strings[attrname]; }

	// bind functions
	this.parseProducts = this.parseProducts.bind(this);
	this.getDocuments = this.getDocuments.bind(this);
	this.parseDocuments = this.parseDocuments.bind(this);
	this.statusUpdate = this.statusUpdate.bind(this);
	this.setupDocumentForm = this.setupDocumentForm.bind(this);

	if(typeof this.options.ajaxDocumentsUrl != 'string' || typeof this.options.ajaxProductsUrl != 'string'){
		this.statusUpdate('Cannot make ajax request, url not available or not wel formed.', 'error');
		return;
	}

	// get form input name for the basket
	if(this.htmlElements.basketContainer){
		let node = this.htmlElements.basketContainer;
		while(!node.getAttribute('data-name') && node.nodeName != 'FORM'){
			node = node.parentNode;
		}

		if(node.getAttribute('data-name')){
			this.basketElementInputName = node.getAttribute('data-name');
		}
	}

	// requests
	this.parseProductsRequest = new XMLHttpRequest();
	this.parseProductsRequest.addEventListener('readystatechange', this.parseProducts);

	this.parseDocumentsRequest = new XMLHttpRequest();
	this.parseDocumentsRequest.addEventListener('readystatechange', this.parseDocuments);

	if(this.options.productId){
		// product id is set so get documents
		this.getDocuments(this.options.productId, 'product');
	}
	else {
		// no product id set so get products and product types
		let formData = '';

		if(this.options.currentSection){
			formData += '&section=' + this.options.currentSection;
		}

		if(this.options.docTypes){
			formData += '&types=' + this.options.docTypes.join(',');
		}
	
		if(this.options.sourceTypes){
			formData += '&source-types=' + this.options.sourceTypes.join(',');
		}
		
		this.parseProductsRequest.open('POST', this.options.ajaxProductsUrl);
		this.parseProductsRequest.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
		this.parseProductsRequest.send(formData);

		this.statusUpdate(this.strings.loading, 'loading');
	}
}

Documents.prototype.parseProducts = function(){
	if(this.parseProductsRequest.readyState != 4) return;
	if(this.parseProductsRequest.status != 200 && this.parseProductsRequest.status != 304) {
		console.log('HTTP error ' + this.parseProductsRequest.status);
		return;
	}

	this.statusUpdate(false);
	
	if(!this.parseProductsRequest.responseText){
		this.statusUpdate(this.strings.noDocumentsFound);
		return;
	}

	this.productData = JSON.parse(this.parseProductsRequest.responseText);
	
	this.setupProductTypeForm();
	
	// if the default product is set, check for its existence and load the documents
	if(this.options.defaultProductType){
		for(let i=0;i<this.productData.length;i++){
			if(this.productData[i].id == this.options.defaultProductType){
				this.getDocuments(this.options.defaultProductType);
				break;
			}
		}
	}
};

Documents.prototype.setupProductTypeForm = function(){
	if(Array.isArray(this.productData) && this.productData.length > 0){
		let docTitleWrapper = document.createElement('div');
		docTitleWrapper.setAttribute('class', 'documents-documents-title-container');

		let selectTypeTitle = document.createElement('span');
		selectTypeTitle.setAttribute('class', 'documents-documents-title');
		selectTypeTitle.appendChild(document.createTextNode(this.strings.chooseYourProduct));
		docTitleWrapper.appendChild(selectTypeTitle);
		this.htmlElements.productTypesContainer.appendChild(docTitleWrapper);

		let selectElement = document.createElement('select');
		selectElement.setAttribute('name', 'product-type');

		let optionElement = document.createElement('option');
		optionElement.appendChild(document.createTextNode('- ' + this.strings.chooseProduct + ' -'));
		selectElement.appendChild(optionElement);

		for(let i=0;i<this.productData.length;i++){
			let optionElement = document.createElement('option');
			optionElement.appendChild(document.createTextNode(this.productData[i].title));
			optionElement.setAttribute('value', this.productData[i].id);
			
			if(this.options.defaultProductType == this.productData[i].id){
				optionElement.setAttribute('selected', 'selected');
			}
			
			selectElement.appendChild(optionElement);
		}

		this.htmlElements.productTypesContainer.appendChild(selectElement);

		selectElement.addEventListener('change', function(event){
			if(event.currentTarget.value){
				this.currentProductType = event.currentTarget.value;
				this.getDocuments(event.currentTarget.value);
			}
			else {
				this.statusUpdate('No value set.', 'error');
			}
		}.bind(this));
	}
	
	this.eventDispatcher.dispatchEvent(this.events.productsLoaded);
};

Documents.prototype.getDocuments = function(id, idType){
	let formData = '';
	if(idType == 'product'){
		formData = 'product_id=' + id;
	}
	else {
		formData = 'product_type_id=' + id;
	}

	if(this.options.currentSection){
		formData += '&section=' + this.options.currentSection;
	}

	if(this.options.docTypes){
		formData += '&types=' + this.options.docTypes.join(',');
	}

	if(this.options.sourceTypes){
		formData += '&source-types=' + this.options.sourceTypes.join(',');
	}
	
	this.parseDocumentsRequest.open('POST', this.options.ajaxDocumentsUrl);
	this.parseDocumentsRequest.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	this.parseDocumentsRequest.send(formData);

	this.statusUpdate(this.strings.loading, 'loading');
};

Documents.prototype.parseDocuments = function(){
	if(this.parseDocumentsRequest.readyState != 4) return;
	if(this.parseDocumentsRequest.status != 200 && this.parseDocumentsRequest.status != 304) {
		console.log('HTTP error ' + this.parseDocumentsRequest.status);
		return;
	}

	this.statusUpdate(false);

	if(!this.parseDocumentsRequest.responseText){
		this.statusUpdate(this.strings.noDocumentsFound);
		return;
	}

	this.documentData = JSON.parse(this.parseDocumentsRequest.responseText);

	this.setupDocumentForm(this.documentData);// hmm, chaining = bad?
};

Documents.prototype.setupDocumentForm = function(documents){
	if(!Array.isArray(documents)){
		return;
	}

	// empty container element
	while(this.htmlElements.documentsContainer.firstChild){
		this.htmlElements.documentsContainer.removeChild(this.htmlElements.documentsContainer.firstChild);
	}

	let docTitleWrapper = document.createElement('div');
	docTitleWrapper.setAttribute('class', 'documents-documents-title-container');
	
	if(this.productData){
		for(let i=0;i<this.productData.length;i++){
			if(this.currentProductType == this.productData[i].id){
				let productTypeTitle = document.createElement('span');
				productTypeTitle.setAttribute('class', 'documents-documents-title');
				productTypeTitle.appendChild(document.createTextNode(this.strings.documents + ' ' + this.productData[i].title));
				docTitleWrapper.appendChild(productTypeTitle);
			}
		}
	}

	let postTitle = document.createElement('span');
	postTitle.setAttribute('class', 'documents-documents-title-post');
	postTitle.appendChild(document.createTextNode(this.strings.receiveByMail));
	docTitleWrapper.appendChild(postTitle);

	/*let downloadTitle = document.createElement('span');
	downloadTitle.setAttribute('class', 'documents-documents-title-download');
	downloadTitle.appendChild(document.createTextNode('Download'));
	docTitleWrapper.appendChild(downloadTitle);*/

	this.htmlElements.documentsContainer.appendChild(docTitleWrapper);

	if(documents.length > 0){
		this.htmlElements.documentListContainerElement = document.createElement('ul');
		this.htmlElements.documentListContainerElement.setAttribute('class', 'documents-documents-container');
		this.htmlElements.documentsContainer.appendChild(this.htmlElements.documentListContainerElement);

		for(let i=0;i<documents.length;i++){

			let listItem = this.createDocumentItem(documents[i]);

			if(listItem.nodeType == 1){
				this.htmlElements.documentListContainerElement.appendChild(listItem);
			}
		}
	}

	this.eventDispatcher.dispatchEvent(this.events.documentsLoaded);
};

Documents.prototype.addToBasket = function(documentId){
	for(let i=0;i<this.htmlElements.basketContainer.childNodes.length;i++){
		if(documentId == this.htmlElements.basketContainer.childNodes[i].getAttribute('data-id')){
			this.htmlElements.basketContainer.childNodes[i].classList.add('is-added');
			return;
		}
	}

	var documentInfo = null;

	for(let i=0;i<this.documentData.length;i++){
		if(this.documentData[i].id == documentId){
			documentInfo = this.documentData[i];
			break;
		}
	}

	if(!documentInfo){
		return;
	}

	let listItem = this.createDocumentItem(documentInfo, 'basket');
	
	if(listItem.nodeType == 1){
		this.htmlElements.basketContainer.appendChild(listItem);

		listItem.addEventListener('transitionend', function(event){
			this.classList.remove('is-added');
		});

		this.htmlElements.addressContainer.classList.add('is-active');

		setTimeout(function(){ this.classList.add('is-added'); }.bind(listItem), 100);
	}
};

Documents.prototype.removeFromBasket = function(documentId){
	for(let i=0;i<this.htmlElements.basketContainer.childNodes.length;i++){
		if(documentId == this.htmlElements.basketContainer.childNodes[i].getAttribute('data-id')){
			this.htmlElements.basketContainer.childNodes[i].parentNode.removeChild(this.htmlElements.basketContainer.childNodes[i]);

			if(this.htmlElements.basketContainer.childNodes.length < 1){
				this.htmlElements.addressContainer.classList.remove('is-active');
			}
			return;
		}
	}
};

Documents.prototype.createDocumentItem = function(documentObject, type = 'default'){
	let listItemElement = document.createElement('li');
	listItemElement.setAttribute('class', 'document-item');	
	listItemElement.setAttribute('data-id', documentObject.id);

	let titleElement = document.createElement('span');
	titleElement.setAttribute('class', 'document-item-title');
	titleElement.appendChild(document.createTextNode(documentObject.title));

	if(documentObject.file.extension != 'pdf'){
		titleElement.appendChild(document.createTextNode(' (' + documentObject.file.extension + ')'));
	}

	listItemElement.appendChild(titleElement);

	if(type == 'basket' && this.basketElementInputName){
		let checkboxElement = document.createElement('input');
		checkboxElement.setAttribute('type', 'checkbox');
		checkboxElement.setAttribute('class', 'document-item-id');
		checkboxElement.value = documentObject.id;
		checkboxElement.setAttribute('name', this.basketElementInputName);
		checkboxElement.checked = true;

		listItemElement.appendChild(checkboxElement);
	}
	
	if(type != 'basket' && documentObject.file && documentObject.file.url){
		let downloadButton = document.createElement('a');
		downloadButton.setAttribute('class', 'document-item-download');
		downloadButton.setAttribute('href', documentObject.file.url);
		downloadButton.setAttribute('target', '_blank');

		listItemElement.appendChild(downloadButton);
	}
	
	switch(type){
		default:
			let postButton = document.createElement('button');
			postButton.setAttribute('class', 'document-item-post');
			postButton.setAttribute('data-id', documentObject.id);

			const labelAdd = document.createElement('span');
			labelAdd.setAttribute('class', 'document-item-post-label-add');
			labelAdd.appendChild(document.createTextNode(this.strings.add));
			postButton.appendChild(labelAdd);

			const labelReceivePost = document.createElement('span');
			labelReceivePost.setAttribute('class', 'document-item-post-label-receive-post');
			labelReceivePost.appendChild(document.createTextNode(this.strings.receiveByMail));
			postButton.appendChild(labelReceivePost);

			if(documentObject.file.mime_type == 'application/pdf' && documentObject.acceptSendByMail){
				postButton.addEventListener('click', function(event){
					if(event.currentTarget.getAttribute('data-id')){
						this.addToBasket(event.currentTarget.getAttribute('data-id'));
					}
					else {
						this.statusUpdate('No value set.', 'error');
					}
				}.bind(this));
			}
			else {
				postButton.classList.add('is-disabled');
			}

			listItemElement.appendChild(postButton);
			break;
		case 'basket':
			if(this.options.allowMultipleCopies && this.basketElementInputName){
				let amountInput = document.createElement('input');
				amountInput.setAttribute('type', 'number');
				amountInput.setAttribute('value', 1);
				amountInput.setAttribute('step', 1);
				amountInput.setAttribute('min', 1);
				amountInput.setAttribute('name', this.basketElementInputName);
				amountInput.setAttribute('class', 'document-item-amount');
				listItemElement.appendChild(amountInput);
			}
			
			break;
	}

	switch(type){
		case 'basket':
			let removeButton = document.createElement('button');
			removeButton.setAttribute('class', 'document-item-remove');
			removeButton.appendChild(document.createTextNode('-'));
			removeButton.setAttribute('data-id', documentObject.id);
			removeButton.addEventListener('click', function(event){
				event.preventDefault();
				if(event.currentTarget.getAttribute('data-id')){
					this.removeFromBasket(event.currentTarget.getAttribute('data-id'));
				}
				else {
					this.statusUpdate('No value set.', 'error');
				}
			}.bind(this));

			listItemElement.appendChild(removeButton);
		break;
	}

	return listItemElement;
};

Documents.prototype.statusUpdate = function(message, type){
	if(message === false){
		//if the statusContainer doesn't exist then stop
		if(!this.htmlElements.statusContainer){
			return;
		}
		
		this.htmlElements.statusContainer.classList.remove('is-active');
		while(this.htmlElements.statusContainer.firstChild){
			this.htmlElements.statusContainer.removeChild(this.htmlElements.statusContainer.firstChild);
		}
		if(this.htmlElements.selectorWrapper){
			this.htmlElements.selectorWrapper.classList.remove('is-loading');
		}

		return;
	}

	if(!type){
		type = 'notice';
	}
	
	//put the error in te console also
	switch(type){
		case 'notice':
		case 'loading':
			console.info(message);
			break;
		case 'warning':
			console.warn(message);
			break;
		case 'error':
			console.error(message);
			break;
	}

	if(type == 'loading' && this.htmlElements.selectorWrapper){
		this.htmlElements.selectorWrapper.classList.add('is-loading');
	}
	else if(this.htmlElements.selectorWrapper){
		this.htmlElements.selectorWrapper.classList.remove('is-loading');
	}

	//if the statusContainer doesn't exist then stop
	if(!this.htmlElements.statusContainer){
		return;
	}

	//remove current message
	while(this.htmlElements.statusContainer.firstChild){
		this.htmlElements.statusContainer.removeChild(this.htmlElements.statusContainer.firstChild);
	}

	var errorElement = document.createElement('p');
	errorElement.appendChild(document.createTextNode(message));
	errorElement.setAttribute('class', 'message documents-message');

	switch(type){
		case 'warning':
			errorElement.classList.add('message-warning');
			break;
		case 'error':
			errorElement.classList.add('message-error');
			break;
	}

	this.htmlElements.statusContainer.appendChild(errorElement);
	this.htmlElements.statusContainer.classList.add('is-active');

	if(type == 'loading'){
		this.htmlElements.statusContainer.classList.add('is-loading');
	}
	else {
		this.htmlElements.statusContainer.classList.remove('is-loading');
	}
};

// polyfill for IE, To do: should not be in this file.
(function () {

	if ( typeof window.CustomEvent === "function" ) return false;
  
	function CustomEvent ( event, params ) {
	  params = params || { bubbles: false, cancelable: false, detail: undefined };
	  var evt = document.createEvent( 'CustomEvent' );
	  evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
	  return evt;
	 }
  
	CustomEvent.prototype = window.Event.prototype;
  
	window.CustomEvent = CustomEvent;
})();

export default Documents;